import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Eye, EyeOff } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { useLang } from "@/contexts/LanguageContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ArchiveNoticeEditor = () => {
  const { authHeaders } = useAuth();
  const { t } = useLang();
  const [form, setForm] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/settings/archive-notice`)
      .then(({ data }) => setForm(data))
      .catch((e) => console.error(e));
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await axios.put(`${API}/admin/settings/archive-notice`, form, { headers: authHeaders() });
      setForm(data);
      toast.success(t.admin.saved);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Error");
    } finally {
      setBusy(false);
    }
  };

  if (!form) return null;

  return (
    <form onSubmit={save} data-testid="archive-notice-form" className="border border-white/10 bg-[var(--hk-surface)] p-6 md:p-8 mb-10">
      <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4 mb-6">
        <div>
          <div className="text-[10px] tracking-[0.35em] text-[var(--hk-red)] font-bold mb-2">// ARCHIVE MESSAGE</div>
          <p className="text-xs text-white/50">
            Message shown on the Archives page between the statistics and the results list. Hide it anytime.
          </p>
        </div>
        <div className="flex border border-white/15 shrink-0" role="group" aria-label="Display">
          <button
            type="button"
            onClick={() => setForm({ ...form, enabled: true })}
            data-testid="archive-notice-enable-btn"
            className={`flex items-center gap-2 px-4 py-2 text-[10px] font-bold tracking-[0.2em] transition-colors ${
              form.enabled ? "bg-[#10B981] text-black" : "text-white/50 hover:text-white"
            }`}
          >
            <Eye size={12} /> SHOWN
          </button>
          <button
            type="button"
            onClick={() => setForm({ ...form, enabled: false })}
            data-testid="archive-notice-disable-btn"
            className={`flex items-center gap-2 px-4 py-2 text-[10px] font-bold tracking-[0.2em] transition-colors ${
              !form.enabled ? "bg-[var(--hk-red)] text-white" : "text-white/50 hover:text-white"
            }`}
          >
            <EyeOff size={12} /> HIDDEN
          </button>
        </div>
      </div>

      <label className="block text-[10px] tracking-[0.25em] text-white/50 mb-2">MESSAGE</label>
      <textarea
        value={form.text}
        onChange={(e) => setForm({ ...form, text: e.target.value })}
        rows={3}
        data-testid="archive-notice-text"
        className="w-full bg-transparent border border-white/15 px-4 py-3 text-sm focus:border-[var(--hk-red)] transition-colors resize-y mb-6"
      />

      <button type="submit" disabled={busy} data-testid="archive-notice-save-btn" className="btn-red px-8 py-3 text-[11px] font-bold tracking-[0.3em]">
        {busy ? "..." : t.admin.save}
      </button>
    </form>
  );
};

export default ArchiveNoticeEditor;
